import { LocaleHelper } from "@nf/common";
import { EXTERNAL_LINKS } from "@nf/constants";
import { useMemo } from "react";
import { useCountry } from "./useCountry";
import { useLanguage } from "./useLanguage";
import { useRouter } from "./useRouter";

const useGetLocalizedAuthUrl = (url: string): string => {
  const { query } = useRouter();
  const country = useCountry();
  const language = useLanguage();

  const utmParams = useMemo(
    () => ({
      utm_source: query.utm_source,
      utm_medium: query.utm_medium,
      utm_campaign: query.utm_campaign,
    }),
    [query]
  );

  return useMemo(() => {
    const baseUrl = LocaleHelper.getLocalizedAuthUrl(url, {
      Language: language,
      Country: country,
    });

    const searchParams = new URLSearchParams();
    Object.entries(utmParams).forEach(([key, value]) => {
      if (value) searchParams.set(key, value);
    });

    const queryString = searchParams.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
  }, [url, country, language, utmParams]);
};

export const useSignUpUrl = (): string => {
  return useGetLocalizedAuthUrl(EXTERNAL_LINKS.SIGNUP);
};

export const useForgotPasswordLink = (): string => {
  return useGetLocalizedAuthUrl(EXTERNAL_LINKS.FORGOT_PASSWORD);
};
